"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = getAssetPathFromRoute;
function getAssetPathFromRoute(route, param) {
    var ext = param === void 0 ? '' : param;
    var path = route === '/' ? '/index' : /^\/index(\/|$)/.test(route) ? "/index".concat(route) : "".concat(route);
    return path + ext;
} //# sourceMappingURL=get-asset-path-from-route.js.map
